import { createReducer, on } from '@ngrx/store';
import {
  attachDocumentsFailed,
  attachDocumentsRequest,
  attachDocumentsSuccess,
  CurrentAction,
  deleteDocumentsFailed,
  deleteDocumentsRequest,
  deleteDocumentsSuccess,
  documentsFailed,
  documentsRequest,
  documentsSuccess,
  omcChangeAction,
  resetLocality,
  setLocality,
} from './registration.actions';
import { CompanyType } from '@shared/enums/company-types';

const initialState: CurrentAction = {
  currentStep: 'sectionA',
  selectedLocality: null,
  documents: { loading: false, data: null, error: null },
  attachDocument: { loading: false, data: null, error: null },
  deleteDocument: { loading: false, data: null, error: null },
};

export const registrationReducer = createReducer(
  initialState,

  on(omcChangeAction, (state, { step }): CurrentAction => {
    return {
      ...state,
      currentStep: step,
    };
  }),

  on(setLocality, (state, { locality }) => ({
    ...state,
    selectedLocality: locality,
    currentStep:
      state.selectedLocality === locality
        ? state.currentStep
        : locality === CompanyType.LOCAL
          ? 'sectionB'
          : 'sectionA',
  })),

  on(resetLocality, (state) => ({
    ...state,
    selectedLocality: null,
  })),

  /* ------------ DOCUMENTS LIST ---------- */
  on(documentsRequest, (state) => ({
    ...state,
    documents: { loading: true, data: null, error: null },
  })),

  on(documentsSuccess, (state, { response }) => ({
    ...state,
    documents: { loading: false, data: response.data, error: null },
  })),

  on(documentsFailed, (state, { error }) => ({
    ...state,
    documents: { loading: false, data: null, error: error.message },
  })),

  /* ------------ DOCUMENTS ATTACHMENT ---------- */
  on(attachDocumentsRequest, (state) => ({
    ...state,
    attachDocument: { loading: true, data: null, error: null },
  })),

  on(attachDocumentsSuccess, (state, { response }) => ({
    ...state,
    attachDocument: { loading: false, data: response.data, error: null },
  })),

  on(attachDocumentsFailed, (state, { error }) => ({
    ...state,
    attachDocument: { loading: false, data: null, error: error.message },
  })),

  /* ------------ DELETE ATTACHMENT ---------- */
  on(deleteDocumentsRequest, (state) => ({
    ...state,
    deleteDocument: {
      ...state.attachDocument,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(deleteDocumentsSuccess, (state, { response }) => ({
    ...state,
    deleteDocument: {
      ...state.attachDocument,
      loading: false,
      data: response.data,
      error: null,
    },
  })),

  on(deleteDocumentsFailed, (state, { error }) => ({
    ...state,
    deleteDocument: {
      ...state.attachDocument,
      loading: false,
      data: null,
      error: error,
    },
  }))
);
